const routeStates = {
    Company: 0,
    Category: 1,
    Service: 2,
    Person: 3,
    Resource: 4,
    Duration: 5,
    Date: 6,
    Time: 7,
    Client: 8,
    Summary: 9,
    Basket: 10,
    Checkout: 11,
    Slot: 12,
    Event: 13,
    Login: 14,
    Questions: 15,
    Confirmation: 16
};

angular
    .module('BB')
    .constant('routeStates', routeStates);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_constants/route_states.constant.js